<template>
  <WdsLabel :success="column.paidAt" :error="!column.paidAt" sm subtle>
    {{ displayStatus }}
  </WdsLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { useTranslation } from '@/composables/translation'

const PaymentRequestClientPaymentStatusColumn = graphql(`
  fragment PaymentRequestClientPaymentStatusColumn on PaymentRequest {
    id
    paidAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestClientPaymentStatusColumn>
}>()

const { $t } = useTranslation()

const column = computed(() => useFragment(PaymentRequestClientPaymentStatusColumn, props.row))

const displayStatus = computed(() => (column.value.paidAt ? $t('Paid') : $t('Not paid')))
</script>

<style scoped></style>
